/**
 * Utility functions for 4-digit passcode management
 */

/**
 * Generates a random 4-digit passcode
 */
export const generatePasscode = (): string => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

/**
 * Validates that a passcode is exactly 4 digits
 */
export const isValidPasscode = (passcode: string): boolean => {
  return /^\d{4}$/.test(passcode);
};

/**
 * Formats a passcode for display (e.g., with dashes or spaces)
 */
export const formatPasscode = (passcode: string): string => {
  return passcode.split('').join(' ');
};

/**
 * Masks a passcode for security display
 */
export const maskPasscode = (passcode: string): string => {
  return '• • • •';
};
